const API_LINK = 'https://erecepta-backend-vercel.vercel.app'

export default API_LINK;